<div class="dashboard-heading">
  <h1>{{ 'SELF_DIAGNOSIS' | translate }}</h1>
</div>
<div class="mb-4">
  <dx-button [disabled]="this.isCreating" text="Додати" icon="mdi mdi-plus" class="btn me-3" (onClick)="this.add()"></dx-button>
  @if (this.isCreating) {
    <dx-button text="Закрити" icon="mdi mdi-close" class="btn" (onClick)="this.addClose()"></dx-button>
  }
</div>
@if (this.isCreating) {
  <self-diagnosis-details (onSave)="this.onSave($event)" class="mb-5"></self-diagnosis-details>
}

<dx-data-grid
  #dataGrid
  class="datagrid-admin mb-3"
  [dataSource]="this.selfDiagnosis"
  keyExpr="id"
  [masterDetail]="{ enabled: true, template: 'details' }"
  [showBorders]="true"
  [hoverStateEnabled]="true"
  [columnMinWidth]="60"
  stylingMode="outlined"
  [allowColumnResizing]="true"
  rowTemplate="rowTemplate"
  noDataText="{{ 'NOT_FOUND' | translate }}">
  <dxo-selection mode="single"></dxo-selection>
  <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>

  <dxi-column dataField="typeId" caption="{{ 'Категория запроса' | translate }}" [width]="200"></dxi-column>
  <dxi-column dataField="nameUa" caption="{{ 'Самодиагностика' | translate }}" [width]="200"></dxi-column>
  <dxi-column dataField="priority" caption="{{ 'Приоритет' | translate }}" [width]="150"></dxi-column>
  <dxi-column dataField="service.category.nameUa" caption="{{ 'Сервис' | translate }}"></dxi-column>
  <dxi-column dataField="service.category.masterCategory.nameUa" caption="{{ 'Мастер категория' | translate }}"></dxi-column>
  <dxi-column [width]="80" caption="{{ 'Удалить' | translate }}"></dxi-column>

  <tbody class="dx-row" *dxTemplate="let row of 'rowTemplate'">
    <tr class="main-row">
      <td>
        @if (row.isExpanded) {
          <dx-button class="btn btn-transparent" icon="mdi mdi-minus mdi-18px" (onClick)="this.rowCick(row)"></dx-button>
        }
        @if (!row.isExpanded) {
          <dx-button class="btn btn-transparent" icon="mdi mdi-plus mdi-18px" (onClick)="this.rowCick(row)"></dx-button>
        }
      </td>
      <td>
        {{ (serviceTypeFacade.getById(row.data.typeId) | async).nameUa }}
      </td>
      <td>
        {{ row.data.nameUa }}
      </td>
      <td>
        {{ row.data.priority }}
      </td>
      <td>
        {{ row.data.service.category.nameUa }}
      </td>
      <td>
        {{ row.data.service.category.masterCategory.nameUa }}
      </td>
      <td>
        <dx-button icon="mdi mdi-close-circle" class="btn-icon color-red" (onClick)="this.delete(row)"></dx-button>
      </td>
    </tr>
  </tbody>

  <div *dxTemplate="let row of 'details'">
    <self-diagnosis-details [entityId]="row.data.id" (onSave)="this.onSave($event)"></self-diagnosis-details>
  </div>

  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 50, 100, 1000]"></dxo-pager>
</dx-data-grid>
